// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"137":"revew","328":"admin","535":"login","757":"game","908":"history","983":"report"}[chunkId] + "." + {"137":"c48f45b9","328":"7b17c2a7","535":"81fb50fc","757":"65c9b6b3","908":"983c5a20","983":"c62371e4"}[chunkId] + ".css";
};